<app-header-layout [userLogin]="userLogin" *ngIf="showHeader"> </app-header-layout>
<div class="signup-free">
  <div class="signup-free__info">
    <div class="signup-free__info-header">
      <h1>Fishidy’s the <h1 class="signup-free__info-header__bold">best</h1>
      </h1>
      <span>Cast with confidence and join over 1 million other anglers already having more success on the water</span>
    </div>
    <div class="signup-free__info-reminder">
      <h1>Reminder why you’re joining</h1>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__checkbox">
          <div class="checkbox">
            <input type="checkbox" value="None" id="checkbox" name="check" checked />
            <label for="checkbox"></label>
          </div>
        </div>
        <span>The fishing map</span>
      </div>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__checkbox">
          <div class="checkbox">
            <input type="checkbox" value="None" id="checkbox" name="check" checked />
            <label for="checkbox"></label>
          </div>
        </div>
        <span>Activity</span>
      </div>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__checkbox">
          <div class="checkbox">
            <input type="checkbox" value="None" id="checkbox" name="check" checked />
            <label for="checkbox"></label>
          </div>
        </div>
        <span>Catches & Spots</span>
      </div>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__checkbox">
          <div class="checkbox">
            <input type="checkbox" value="None" id="checkbox" name="check" checked />
            <label for="checkbox"></label>
          </div>
        </div>
        <span>Braggin’ board</span>
      </div>
    </div>
    <div class="signup-free__info-reminder">
      <h2>Without <span class="orange">Premium</span> you'll miss out on valuable features:</h2>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__uncheckbox">
          <div class="uncheckbox">
            <label class="line1"></label>
            <label class="line2"></label>
          </div>
        </div>
        <span>Fishing Hot Spots & Tips</span>
      </div>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__uncheckbox">
          <div class="uncheckbox">
            <label class="line1"></label>
            <label class="line2"></label>
          </div>
        </div>
        <span>Underwater Structure & Habitat</span>
      </div>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__uncheckbox">
          <div class="uncheckbox">
            <label class="line1"></label>
            <label class="line2"></label>
          </div>
        </div>
        <span>Enhanced Fishing Forecast</span>
      </div>
      <div class="signup-free__info-reminder__data">
        <div class="signup-free__info-reminder__uncheckbox">
          <div class="uncheckbox">
            <label class="line1"></label>
            <label class="line2"></label>
          </div>
        </div>
        <span>Offline Mapping</span>
      </div>
      <div class="signup-free__info-reminder__button">
        <button class="button button-premium" [routerLink]="relativePaths.SIGN_UP_PREMIUM">Go Premium</button>
      </div>
      
    </div>
    <img src="/assets/images/sign-up/sign-up-free-img.png" />
  </div>

  <div class="signup-free__form-register">
    <app-sign-up-form
      [isFetching]="(signup$ | async).isLoading"
      [error]="(signup$ | async).error"
      (submitted)="handleSignUpFree($event)"
    ></app-sign-up-form>
  </div>
</div>
